module.exports = __webpack_public_path__ + "img/List.468c588b.svg";